/**
 * @author: lv.chen
 * @date: 2025/8/4
 * @desc: Content Management Center页面
 */
import React from 'react';
import classnames from 'classnames';
import { useIntl, history } from 'umi';
import { Layout, Tabs } from 'tea-component';
import useContentManagementCenterActiveId from './_hooks/useContentManagementCenterActiveId';

import './index.scss';

const { Body, Content } = Layout;

interface IContentManagementCenterProps extends IBaseProps {}

const ContentManagementCenter: React.FC<IContentManagementCenterProps> = (props) => {
  const { style, className, children } = props;

  const { formatMessage } = useIntl();

  const tabs = [
    {
      id: 'reports',
      label: formatMessage({ id: 'dbu_common_reports' }),
    },
  ];

  const [activeId, setActiveId] = useContentManagementCenterActiveId();

  return (
    <Layout style={style} className={classnames('dbu-content-management-center-layout', className)}>
      <Body>
        <Content>
          <Content.Header
            title={formatMessage({ id: 'dbu_content_management_center_title' })}
            subtitle={formatMessage({ id: 'dbu_content_management_center_subtitle' })}
          >
            <Tabs
              className="dbu-content-management-center-tabs"
              tabs={tabs}
              animated={false}
              activeId={activeId}
              onActive={(tab) => {
                const tabId = tab?.id || '';
                setActiveId(tabId);
                history.replace(`/user-center/content-management-center/${tabId}`);
              }}
            />
          </Content.Header>
          <Content.Body full>{children}</Content.Body>
        </Content>
      </Body>
    </Layout>
  );
};

export default ContentManagementCenter;
